import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { selectUser } from '../../store/selectors/auth.selectors';
import { ROUTES } from '../../shared/constants';

@Injectable({
  providedIn: 'root',
})
class ProtectedGuardService {
  constructor(
    private _store: Store,
    private _router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._store.select(selectUser).pipe(
      take(1),
      map((user) => {
        if (!user) {
          this._router.navigate([ROUTES.SIGN_IN]);
          return false;
        }

        // Block access if user must change password or email is not active
        const mustChangePassword = user.mustChangePassword === true || user.mustChangePassword == null;
        const isEmailInactive = user.isEmailActive === false;

        if (mustChangePassword || isEmailInactive) {
          // Only redirect if not already on reset-password route to avoid redirect loops
          if (!state.url.startsWith('/reset-password')) {
            const encoded = encodeURIComponent(JSON.stringify({ email: user.email }));
            this._router.navigate([ROUTES.RESET_PASSWORD], {
              queryParams: { data: encoded },
            });
          }
          return false;
        }

        return true;
      })
    );
  }
}

export const ProtectedGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  return inject(ProtectedGuardService).canActivate(next, state);
};
